import { render } from "./SideBar.vue?vue&type=template&id=765a4163"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__